import { LoadingSkeleton, PageHeader, Tag } from "shared-components";

import { ExpandableText } from "@/components/ExpandableText";
import { useSetResponsiveElementsDisplay } from "@/hooks/use-set-responsive-elements-display";

import { ProductTechnicalData } from "./TechnicalData";

import type { JSX } from "react";

interface Props {
  themes: { id: string; name: string }[];
  description: string;
  technicalData: string[];
  className?: string;
  loading?: boolean;
}

export const ProductDescription = ({ themes, description, technicalData, className, loading }: Props): JSX.Element => {
  const { expandableTextSettings, setExpandableTextRef, toggleExpandableText } = useSetResponsiveElementsDisplay();

  return (
    <div className={className}>
      <PageHeader title="Descrição do produto" />

      <div className="mt-2 flex gap-2">
        {loading
          ? Array.from({ length: 2 }, (_, index) => (
              <LoadingSkeleton kind="tag" key={index} className="brand-primary-opacity-10 lg:w-[9.5rem]" />
            ))
          : themes.map(({ id, name }) => <Tag key={id} name={name} color="brand-primary" />)}
      </div>

      <ExpandableText
        ref={setExpandableTextRef}
        className="mt-2"
        text={description}
        expandableTextSettings={expandableTextSettings}
        toggleExpand={toggleExpandableText}
        loading={loading}
        isDesktopExpandable
      />

      <ProductTechnicalData technicalData={technicalData} loading={loading} className="mt-3" />
    </div>
  );
};
